import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ModalBuilderComponent } from './pages/modal-builder/modal-builder.component';
import { ExternalApiComponent } from './pages/external-api/external-api.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { CaseStudiesComponent } from './pages/case-studies/case-studies.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AboutComponent } from './pages/about/about.component';
import { AccountManagerComponent } from './pages/account-manager/account-manager.component';
import { UserManagerComponent } from './pages/user-manager/user-manager.component';
import { SiteManagerComponent } from './pages/site-manager/site-manager.component';
import { PontRxDemoComponent } from './pages/pontrx-demo/pontrx-demo.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'about-us', component: AboutComponent, pathMatch: 'full' },
  { path: 'case-studies', component: CaseStudiesComponent, pathMatch: 'full' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, pathMatch: 'full' },
  
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
  { path: 'modal-builder', component: ModalBuilderComponent, canActivate: [AuthGuard]},
  { path: 'external-api', component: ExternalApiComponent, canActivate: [AuthGuard]},
  { path: 'admin/accounts', component: AccountManagerComponent, canActivate: [AuthGuard] },
  { path: 'admin/users', component: UserManagerComponent, canActivate: [AuthGuard] },
  { path: 'admin/sites', component: SiteManagerComponent, canActivate: [AuthGuard] },
  { path: 'admin/demo', component: PontRxDemoComponent, canActivate: [AuthGuard] },

  // 404
  { path: '**', component: HomeComponent , redirectTo: '', pathMatch: 'full' },
  
  // SEO redirects from site redesign
  { path: 'lets-chat', redirectTo: '/', pathMatch: 'full' },
  { path: 'services/strategy', redirectTo: '/case-studies', pathMatch: 'full' },
  { path: 'services/development', redirectTo: '/case-studies', pathMatch: 'full' },
  { path: 'services/design', redirectTo: '/case-studies', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
